import React from 'react';
import styles from './Discount.module.css';

const Discount = () => {
  return (
    <div className={styles.discount}>
      <span className={styles.label}>UPGRADE DISCOUNT</span>
      <h2 className={styles.title}>Upgrade today to enable unlimited projects.</h2>
      <div className={styles.price}>$12.99</div>
      <div className={styles.discountCode}>
        <span>DISCOUNT CODE</span>
        <div className={styles.barcode}>G152FG35</div>
      </div>
    </div>
  );
};

export default Discount;